export const SimpleInstance = () => {
    return globalThis.Simple_;
};
//# sourceMappingURL=instance.js.map